import { render, staticRenderFns } from "./dialog-edit-contact.vue?vue&type=template&id=00af20e8&scoped=true"
import script from "./dialog-edit-contact.vue?vue&type=script&lang=js"
export * from "./dialog-edit-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00af20e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00af20e8')) {
      api.createRecord('00af20e8', component.options)
    } else {
      api.reload('00af20e8', component.options)
    }
    module.hot.accept("./dialog-edit-contact.vue?vue&type=template&id=00af20e8&scoped=true", function () {
      api.rerender('00af20e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact/dialog-edit-contact.vue"
export default component.exports